import React from "react";
import img from "../../../assets/images/profile.jpg";
import Transition from "../../../client/common/Transition/Animation";
import Profile from "./Profile/Profile.jsx";
import style from "./home.scss";

const HomePage = () => {
  return (
    <Transition>
      <div className={style["home"]}>
        <div className={style["home-header"]}>
          <div className={style["heading"]}>
            <div className={style["name-text"]}>MADHUR GUPTA</div>
            <div className={style["role-text"]}>
              FULL STACK SOFTWARE ENGINEER FOR REACT.JS, NODE.JS AND JAVA
            </div>
          </div>
          <div className={style["profile-img"]}>
            <div className={style["inner-border"]}>
              <div className={style["outer-border"]}>
                <div className={style["image-div"]}>
                  <img src={img} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style["home-body"]}>
          <Profile />
        </div>
      </div>
    </Transition>
  );
};

export default HomePage;
